import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
import { Diagnosis } from '../types';

export const useDiagnosis = () => {
  const { api } = useApi();
  const { userToken } = useAuth();

  const fetchDiagnoses = async (): Promise<Diagnosis[]> => {
    const requestObj = {
      route: '/private/diagnosis/',
      token: userToken,
    };

    return await api(requestObj);
  };

  const { data, isLoading, isError } = useQuery<Diagnosis[], Error>({
    queryKey: ['hc-diagnosis-select', userToken],
    queryFn: () => fetchDiagnoses(),
    enabled: !!userToken,
    refetchOnWindowFocus: false,
  });

  return {
    data, isLoading, isError
  }
};
